
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.005.25a.75.75 0 000 1.5V.25zm1.81.75l.728-.182A.75.75 0 002.816.25V1zm9.777 10.139a.75.75 0 100-1.5v1.5zm1.448-8.695l.728.183a.75.75 0 00-.728-.933v.75zm-1.448 5.778v.75a.75.75 0 00.727-.567l-.727-.183zM1.005 1.75h1.81V.25h-1.81v1.5zm1.083-.568l.362 1.445 1.455-.365L3.543.818l-1.455.364zm.362 1.445L3.9 8.405l1.455-.365-1.449-5.778-1.455.365zm2.176 4.845h-.362v1.5h.362v-1.5zm-.362 3.667h8.328v-1.5H4.264v1.5zM2.428 9.306c0 1.014.824 1.833 1.836 1.833v-1.5a.335.335 0 01-.336-.333h-1.5zm1.836-1.834a1.835 1.835 0 00-1.836 1.834h1.5c0-.183.148-.334.336-.334v-1.5zM3.178 3.194H14.04v-1.5H3.178v1.5zm10.134-.932L11.864 8.04l1.455.365 1.448-5.778-1.454-.365zm-.72 5.21H4.626v1.5h7.966v-1.5zm-.75 5.806c0-.017.013-.028.026-.028v1.5c.812 0 1.474-.657 1.474-1.472h-1.5zm.026-.028c.012 0 .025.01.025.028h-1.5c0 .815.662 1.472 1.475 1.472v-1.5zm.025.028a.027.027 0 01-.025.028v-1.5c-.813 0-1.475.657-1.475 1.472h1.5zm-.025.028a.027.027 0 01-.026-.028h1.5c0-.815-.662-1.472-1.474-1.472v1.5zM4.6 13.278c0-.017.014-.028.026-.028v1.5c.812 0 1.474-.657 1.474-1.472H4.6zm.026-.028c.012 0 .026.01.026.028h-1.5c0 .815.662 1.472 1.474 1.472v-1.5zm.026.028a.027.027 0 01-.026.028v-1.5c-.812 0-1.474.657-1.474 1.472h1.5zm-.026.028a.027.027 0 01-.026-.028h1.5c0-.815-.662-1.472-1.474-1.472v1.5z","fill":"#585858"}})])
          )
        }
      }
    